export function AppVersion() {
  return (
    <p className="text-center text-xs text-transparent">
      v{__APP_INFO__.version} ({__APP_INFO__.commitHash.slice(0, 4)})
    </p>
  );
}
